import type {
  GetBoardsItemResponse,
  GetBoardsResponse,
} from '@/open-api/model';

/**
 * Matches the word "favorites" or "favourites" regardless of case
 */
const REGEX = /^favou*rites$/i;

export const getFavoritesBoardId = ({
  data,
}: {
  data: GetBoardsResponse | GetBoardsItemResponse[];
}) => {
  if (!data) {
    return null;
  }

  if ('boards' in data) {
    return (
      data?.boards?.find((board) => board && REGEX.test(board.name))?.id ?? null
    );
  }

  return data.find((board) => board && REGEX.test(board.name))?.id ?? null;
};
